export default {
  fields: {
    firstname: {
      label: 'Jméno',
    },
    lastname: {
      label: 'Příjmení',
    },
    phone: {
      label: 'Telefon',
      error: 'Zadejte platné telefonní číslo',
    },
    birthNumber: {
      label: 'Rodné číslo',
      tooltip: 'Vaše rodné číslo potřebujeme pro ověření identity a budeme s ním nakládat bezpečně.',
    },
    permanentAddress: {
      label: 'Adresa trvalého bydliště',
      errorMessages: {
        required: 'Adresa trvalého bydliště musí být vybrána.',
        choosed: 'Adresa trvalého bydliště musí být vybrána ze seznamu adres.',
      },
    },
    identityCard: { label: 'Číslo občanského průkazu' },
  },
  actions: {
    getLoan: 'ZAŽÁDAT O úvěr',
    back: '< ZPĚT',
  },
  errors: {
    default: 'Nedaří se pokračovat ve formuláři. Zkuste to, prosím, znovu.',
    identityCardInvalid: 'Číslo občanského průkazu je neplatné.',
    birthNumber: 'Rodné číslo je neplatné.',
    companyIdNotFound: 'IČO {companyId} nenalezeno',
  },
};
